import React, { ReactNode } from 'react';
import styled from 'styled-components';
import KubitModal from '../KubitModal';
import { ModalActions } from '../KubitModal/KubitModalUI';
import { DangerButton, PrimaryButton, SecondaryButton } from '../Button';
import { theme } from '../../styles/theme';

interface IProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => Promise<any> | void;
  header: string;
  children: ReactNode;
  confirmActionLabel: string;
  cancelActionLabel?: string;
  disabled?: boolean;
  // modalType differentiates what submit button would be used
  modalType?: 'danger' | 'primary';
  trackContext?: string;
  trackCancelAction?: string;
  trackConfirmAction?: string;
}

const Content = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${theme.colors.secondary600};
  strong {
    font-weight: 600;
  }
`;

export default ({
  open,
  onClose,
  onSubmit,
  header,
  children,
  confirmActionLabel,
  cancelActionLabel,
  disabled,
  modalType = 'danger',
  trackContext,
  trackCancelAction,
  trackConfirmAction,
}: IProps) => (
  <KubitModal open={open} header={header} onClose={onClose}>
    <Content>{children}</Content>
    <ModalActions>
      <SecondaryButton
        type="button"
        onClick={onClose}
        trackContext={trackContext}
        trackAction={trackCancelAction}
      >
        {cancelActionLabel ?? 'Cancel'}
      </SecondaryButton>
      {modalType === 'danger' ? (
        <DangerButton
          type="button"
          onClick={onSubmit}
          disabled={disabled}
          trackContext={trackContext}
          trackAction={trackConfirmAction}
        >
          {confirmActionLabel}
        </DangerButton>
      ) : (
        <PrimaryButton
          type="button"
          onClick={onSubmit}
          disabled={disabled}
          trackContext={trackContext}
          trackAction={trackConfirmAction}
        >
          {confirmActionLabel}
        </PrimaryButton>
      )}
    </ModalActions>
  </KubitModal>
);
